import { Component } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';

@Component({
  selector: 'labeled-multi-select',
  template: `
  <mat-form-field>
    <mat-label>{{to.label}}</mat-label>
    <mat-select [formControl]="formControl" multiple (openedChange)="openedChanged($event)">
      <mat-select-trigger>
        {{ displaySelectedOptions() }}
      </mat-select-trigger>
      <mat-option *ngFor="let option of to.options" [value]="option.value">{{option.label}}</mat-option>
    </mat-select>
  </mat-form-field>
  `,
})

export class BasicLabeledMultiSelectComponent extends FieldType<FieldTypeConfig> {
  displaySelectedOptions = () => {
    let result = 'Select an option';
    if (this.formControl.value && this.formControl.value.length && this.to.options) {
      const indexOfValue = (this.to.options as any).findIndex(option => option.value === this.formControl.value[0]);
      result = this.to.options[indexOfValue].label;
      if (this.formControl.value.length > 1) {
        const amountOthers = this.formControl.value.length - 1;
        result += ` (${amountOthers} ${amountOthers === 1 ? 'other' : 'others'})`;
      }
    }

    return result;
  };

  openedChanged = (open) => {
    if (!open && this.to.change) {
      this.to.change({key: this.key});
    }
  };
}
